//replaces single-metric-website-overview-change-pop.html
import type { FC } from "react";

import classNames from "classnames";

import { SWReactIcons } from "@similarweb/icons";

import ContactUsButton from "app/components/ContactUs/ContactUsButton";
import type { IDashboardWidgetInterface } from "app/components/widget/utils/DashboardWidgetsInterfaces-v2";
import type { IWidget } from "app/components/widget/widget-types/Widget";
import { changeFilter, minVisitsAbbrFilter } from "app/filters/ngFilters";

interface ISingleMetricWebsiteOverviewChangePopWidget extends IWidget<any> {
    periodsData?: any;
}
export const SingleMetricWebsiteOverviewChangePopTemplateV2: FC<
    IDashboardWidgetInterface<ISingleMetricWebsiteOverviewChangePopWidget>
> = (props) => {
    const { widget } = props;
    return (
        <div className="period-over-period-single-metric-container">
            {!widget?.periodsData[0].restricted ? (
                <div className="period-over-period-change">
                    <span
                        className={classNames("changePercentage", {
                            positive: widget?.periodsData[1].change > 0,
                            negative: widget?.periodsData[1].change < 0,
                        })}
                    >
                        {changeFilter()(widget?.periodsData[1].change)}
                    </span>
                </div>
            ) : null}
            <div
                className={classNames("period-over-period-visits", {
                    "is-restricted": widget?.periodsData[0].restricted,
                })}
            >
                <div
                    className={"period-over-period-visits-item"}
                    style={{ marginRight: 8 }}
                >
                    <div className="period-over-period-visits-item-data">
                        {!widget.periodsData[0].restricted ? (
                            <div
                                className="period-over-period-visits-item-data-value"
                                style={{ color: widget.periodsData[0].color }}
                                data-color={widget.periodsData[0].color}
                            >
                                {minVisitsAbbrFilter()(widget?.periodsData[0].visits)}
                            </div>
                        ) : null}
                        {widget?.periodsData[0].restricted ? (
                            <div className="period-over-period-visits-item--restricted">
                                <SWReactIcons
                                    iconName="private"
                                    className="icon-lock"
                                />
                            </div>
                        ) : null}
                        <div className="period-over-period-visits-item-data-duration">
                            {widget?.periodsData[0].duration}
                        </div>
                    </div>
                    <div className="period-over-period-visits-item-bar">
                        <div
                            className="period-over-period-visits-item-bar-inner"
                            style={{
                                height: widget.periodsData[0].barHeight,
                                backgroundColor: widget.periodsData[0].color,
                            }}
                        />
                    </div>
                </div>
                <div className="period-over-period-visits-item">
                    <div className="period-over-period-visits-item-bar">
                        <div
                            className="period-over-period-visits-item-bar-inner"
                            style={{
                                height: widget.periodsData[1].barHeight,
                                backgroundColor: widget.periodsData[1].color,
                            }}
                        />
                    </div>
                    <div className="period-over-period-visits-item-data">
                        <div
                            className="period-over-period-visits-item-data-value"
                            ng-style={{ color: widget.periodsData[1].color }}
                            data-color={widget.periodsData[1].color}
                        >
                            {minVisitsAbbrFilter()(widget.periodsData[1].visits)}
                        </div>
                        <div className="period-over-period-visits-item-data-duration">
                            {widget.periodsData[1].duration}
                        </div>
                    </div>
                </div>
            </div>
            {widget.periodsData[0].restricted ? (
                <div className="upgrade-container">
                    <ContactUsButton
                        label={"Hook"}
                        text="research.homepage.upgrade"
                    />
                </div>
            ) : null}
        </div>
    );
};
